import { render, staticRenderFns } from "./modelFive.vue?vue&type=template&id=3c4d2945&scoped=true&"
import script from "./modelFive.vue?vue&type=script&lang=js&"
export * from "./modelFive.vue?vue&type=script&lang=js&"
import style0 from "./modelFive.vue?vue&type=style&index=0&id=3c4d2945&lang=scss&scoped=true&"
import style1 from "./modelFive.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4d2945",
  null
  
)

export default component.exports